export enum OrderStatusEnum {
  PENDING = 'pending',
  QUEUE = 'queue',
  PICKING = 'picking',
  PICKED = 'picked',
  CHECKING = 'checking',
  PACKING = 'packing',
  UPDATING = 'updating',
  UPDATE_FAILED = 'update-failed',
  PACKED = 'packed',
  CANCELLED = 'cancelled',
  NON_PICKED = 'non-picked',
}

export enum OrderSearchCriteriaEnum {
  ALL = 'all',
  PENDING = 'pending',
  QUEUE = 'queue',
  ASSIGNED = 'assigned',
  PICKING = 'picking',
  PICKED = 'picked',
  CHECKING = 'checking',
  UPDATING = 'updating',
  UPDATE_FAILED = 'update-failed',
  PACKING = 'packing',
  PACKED = 'packed',
  CANCELLED = 'cancelled',
  NON_PICKED = 'non-picked',
}
